const quotationChat = {
  quotationChatNavLabel: "Obrolan Penawaran", // translated 
  quotationChatApprovalTitle: "Obrolan Penawaran", // translated 
  quotationChatAccountNotApprovedTitle: "Akun Belum Disetujui", // translated 
  quotationChatAccountNotApprovedDescription:
    "Akun Anda belum disetujui. Silakan hubungi manajer akun Anda untuk informasi lebih lanjut.", // translated 
  quotationChatViewAiChat: "Lihat Obrolan AI", // translated 
  quotationRequestChatSessions: "Sesi obrolan", // translated 
  quotationRequestChatNoPastSessions: "Tidak ada sesi sebelumnya", // translated 
  quotationRequestChatNewChat: "Obrolan Baru", // translated 
  quotationRequestChatCloseSidebar: "Tutup bilah sisi", // translated 
  quotationRequestChatSessionFallback: "Sesi obrolan", // translated 
  quotationRequestChatDefaultSessionName: "Sesi Obrolan Baru", // translated 
  quotationRequestChatTitle: "Obrolan Permintaan Penawaran", // translated 
  quotationRequestChatResponseLanguageLabel: "Bahasa respons", // translated 
  quotationRequestChatOpenSidebar: "Buka bilah sisi", // translated 
  quotationRequestChatRenameSession: "Ubah nama sesi", // translated 
  quotationRequestChatDeleteSession: "Hapus sesi", // translated 
  quotationRequestChatToggleDarkMode: "Alihkan mode gelap", // translated 
  quotationRequestChatSwitchToLightMode: "Beralih ke mode terang", // translated 
  quotationRequestChatSwitchToDarkMode: "Beralih ke mode gelap", // translated 
  quotationRequestChatEmptyStateHeading: "Mulai Percakapan Pernyataan Penawaran Baru", // translated 
  quotationRequestChatEmptyStateSubheading:
    "Menjelaskan kebutuhan perjalanan Anda dan saya akan membuat permintaan penawaran untuk Anda.", // translated 
  quotationRequestChatMessagePlaceholderStart:
    "Ketik pesan Anda untuk memulai percakapan... (Shift+Enter untuk baris baru)", // translated 
  quotationRequestChatMessagePlaceholder:
    "Ketik pesan Anda... (Shift+Enter untuk baris baru)", // translated 
  quotationRequestChatUploadFile: "Berkas Unggah", // translated 
  quotationRequestChatUploadAttachment: "Unggah tamba", // translated 
  quotationRequestChatStopGenerating: "Hentikan Pembuatan", // translated 
  quotationRequestChatGenerateQuotation: "Buat penawaran", // translated 
  quotationRequestChatGenerateFinalQuotation: "Buat Penawaran Final", // translated 
  quotationRequestChatFinalizeQuotationRequest: "Selesaikan Permohonan Penawaran", // translated 
  quotationRequestChatHoldToRecord: "Tahan untuk merekam pesan suara", // translated 
  quotationRequestChatRecordingReleaseToSend: "Merekam, kecewa untuk mengirim", // translated 
  quotationRequestChatRecording: "Merekam...", // translated 
  quotationRequestChatSelectSessionFirst: "Silakan pilih sesi diskusi terlebih dahulu.", // translated 
  quotationRequestChatCancelVoiceRecording: "Batalkan rekaman suara", // translated 
  quotationRequestChatListening: "Mendengarkan...", // translated 
  quotationRequestChatTranscribing: "Mentranskripsi...", // translated 
  quotationRequestChatFileUploadedSuccess: "File berhasil diunggah.", // translated 
  quotationRequestChatFailedCreateSession: "Gagal membuat sesi diskusi. Silakan coba lagi.", // translated 
  quotationRequestChatFailedUploadFile: "Gagal mengunggah file. Silakan coba lagi.", // translated 
  quotationRequestChatAnswerPendingBeforeMessage:
    "Harap jawab pertanyaan yang tertunda sebelum mengirim pesan lain.", // translated 
  quotationRequestChatAnswerPendingBeforeFinalize:
    "Harap jawab pertanyaan yang tertunda sebelum menyelesaikan permintaan penawaran.", // translated 
  quotationRequestChatFavoriteMarked: "Sesi percakapan ditandai sebagai favorit", // translated 
  quotationRequestChatFavoriteUnmarked: "Sesi dialog tidak lagi ditandai sebagai favorit", // translated 
  quotationRequestChatFailedSetFavorite: "Gagal menetapkan favorit", // translated 
  quotationRequestChatFailedUnsetFavorite: "Gagal menghapus favorit", // translated 
  quotationRequestChatRenamedSuccess: "Sesi dialog berhasil mengubahnya.", // translated 
  quotationRequestChatFailedRename: "Gagal mengubah nama sesi dialog. Silakan coba lagi.", // translated 
  quotationRequestChatDeletedSuccess: "Sesi dialog berhasil dihapus.", // translated 
  quotationRequestChatFailedDelete: "Gagal menghapus sesi dialog. Silakan coba lagi.", // translated 
  quotationRequestChatAttachmentDeletedSuccess: "Lampiran gagal dihapus.", // translated 
  quotationRequestChatFailedDeleteAttachment: "Gagal menghapus lampiran. Silakan coba lagi.", // translated 
  quotationRequestChatSubmittedSuccess:
    "permintaan penawaran berhasil dikirim! Permintaan Anda sedang diproses.", // translated 
  quotationRequestChatFailedSubmit: "Gagal mengirim permintaan penawaran", // translated 
  quotationChatPdfDownloadedSuccess: "PDF berhasil diunduh!", // translated 
  quotationChatFailedGeneratePdf: "Gagal membuat PDF", // translated 
  quotationRequestChatSubagentRequired:
    "Silakan pilih pengguna sub-agen sebelum mengirim permintaan penawaran.", // translated 
  quotationRequestChatAppUserLoading:
    "Profil pengguna aplikasi CRM Anda masih dimuat. Silakan coba lagi sebentar lagi.", // translated 
  quotationRequestChatAppUserMismatch:
    "Profil pengguna aplikasi CRM Anda tidak cocok dengan sesi dialog ini.", // translated 
  quotationRequestChatRenameTitle: "Ubah Nama Sesi Obrolan", // translated 
  quotationRequestChatSessionName: "Nama Sesi", // translated 
  quotationRequestChatEnterSessionName: "Masukkan nama sesi", // translated 
  quotationRequestChatSaving: "Simpan...", // translated 
  quotationRequestChatSave: "Simpan", // translated 
  quotationRequestChatDeleteTitle: "Hapus Sesi obrolan", // translated 
  quotationRequestChatDeleteConfirm: "Apakah Anda yakin ingin menghapus sesi dialog ini?", // translated 
  quotationRequestChatDeleteCannotUndo: "Tindakan ini tidak dapat dibatalkan.", // translated 
  quotationRequestChatDeleting: "Menghapus...", // translated 
  quotationRequestChatDelete: "Hapus", // translated 
  quotationRequestChatAttachmentsTitle: "Lampiran Obrolan Isi Penawaran", // translated 
  quotationRequestChatLoadingAttachments: "Memuat lampiran...", // translated 
  quotationRequestChatNoAttachments: "Tidak ada lampiran ditemukan", // translated 
  quotationRequestChatDeleteAttachment: "Hapus площади", // translated 
  quotationRequestChatUploadingAttachment: "Mengunggah lampiran...", // translated 
  quotationRequestChatUploadingAttachmentWait:
    "Harap tunggu sementara file Anda diunggah.", // translated 
  quotationRequestChatAnswerPendingQuestions: "Jawab Pertanyaan yang Tertunda", // translated 
  quotationRequestChatProposeOwnAnswer: "Usulkan jawaban saya sendiri", // translated 
  quotationRequestChatTypeOwnAnswerPlaceholder: "Ketik jawaban Anda sendiri...", // translated 
  quotationRequestChatAnsweredOfTotal: "{{answered}} dari {{total}} dijawab", // translated 
  quotationRequestChatReadyToSubmit: "Siap dikirim", // translated 
  quotationRequestChatSubmitAll: "Kirim semua", // translated 
  quotationRequestChatRespondToOneQuestion: "Jawab {{count}} pertanyaan", // translated 
  quotationRequestChatRespondToManyQuestions: "Jawab {{count}} pertanyaan", // translated 
  quotationRequestChatFinalizeTitle: "Selesaikan Permohonan Penawaran", // translated 
  quotationRequestChatLoadingSessionData: "Memuat data sesi...", // translated 
  quotationRequestChatErrorLoadingSession: "Terjadi kesalahan saat memuat data sesi. Silakan coba lagi.", // translated 
  quotationRequestChatQuotationTitle: "Judul Penawaran", // translated 
  quotationRequestChatExtraComments: "Komentar Tambahan", // translated 
  quotationRequestChatSubmitting: "Naik...", // translated 
  quotationRequestChatSubmit: "Kirim", // translated 
  quotationRequestChatSubmittingOverlayTitle: "Mengirim permintaan penawaran...", // translated 
  quotationRequestChatSubmittingOverlayDescription:
    "Harap tunggu sementara permintaan penawaran Anda dikirim.", // translated 
  quotationRequestChatSelectSubagent: "Pilih Sub-agen", // translated 
  quotationRequestChatSearchSubagents: "Cari sub-agen...", // translated 
  quotationRequestChatLoadingSubagents: "Memuat sub-agen...", // translated 
  quotationRequestChatNoSubagentsFound: "Sub-agen tidak ditemukan", // translated 
  quotationRequestChatNoSubagentsAvailable: "Tidak ada sub-agen tersedia", // translated 
  quotationRequestChatSelectedSubagent: "Dipilih: {{label}}", // translated 
  quotationRequestChatSubagentUsers: "Pengguna Sub-agen", // translated 
  quotationRequestChatSearchUsers: "Cari pengguna...", // translated 
  quotationRequestChatNoUsersFound: "Pengguna tidak ditemukan", // translated 
  quotationRequestChatNoUsersAvailable: "Tidak ada pengguna yang tersedia", // translated 
  quotationChatDownloadSummaryTitle: "Unduh Ringkasan Penawaran Anda", // translated 
  quotationChatDownloadSummaryDescription:
    "Isi detail Anda di bawah untuk membuat ringkasan PDF penawaran perjalanan yang dipersonalisasi. PDF akan mencakup semua detail perjalanan, destinasi, informasi transportasi, dan rencana perjalanan harian.", // translated 
  quotationChatCustomerTitle: "Gelar", // translated 
  quotationChatSelectTitle: "Pilih gelar", // translated 
  quotationChatHonorificMr: "Tn.", // translated 
  quotationChatHonorificMrs: "Ny.", // translated 
  quotationChatHonorificMs: "Nn.", // translated 
  quotationChatHonorificDr: "Dokter", // translated 
  quotationChatHonorificProf: "Profesor", // translated 
  quotationChatCustomerPhone: "Telepon", // translated 
  quotationChatCustomerCompany: "Perusahaan", // translated 
  quotationChatCustomerMessage: "Pesan", // translated 
  quotationChatCustomerCountry: "Negara", // translated 
  quotationChatGenerating: "Membuat...", // translated 
  quotationChatDownloadPdf: "Unduh PDF", // translated 
  quotationChatTripSummary: "Ringkasan Perjalanan", // translated 
  quotationChatDownloadAsPdf: "Unduh sebagai PDF", // translated 
  quotationChatNoTripSummary: "Tidak ada ringkasan perjalanan untuk sesi ini.", // translated 
  quotationRequestChatThinking: "Berpikir...", // translated 
  quotationRequestChatSources: "Sumber", // translated 
  quotationRequestChatSearchingWebFor: 'Mencari di web untuk: "{{query}}"...', // translated 
  quotationRequestChatServicesByTourOperator: "Layanan yang Dijalankan oleh Tour Operator", // translated 
  quotationRequestChatServicesByCustomer: "Layanan yang Ditangani oleh Pelanggan", // translated 
  quotationRequestChatReadyNotice:
    "Anda sekarang dapat membuat penawaran untuk permintaan ini dengan mengklik tombol di sebelah kanan.", // translated 
  quotationRequestChatGenerateFinalQuotationAria: "Buat penawaran final", // translated 
  quotationRequestChatMaybeYouWantToAsk: "Mungkin Anda ingin bertanya:", // translated 
  quotationRequestChatClickToSendSuggestion: "Klik untuk mengirim pesan ini", // translated 
  quotationRequestChatAddToFavorites: "Tambahkan ke favorit", // translated 
  quotationRequestChatRemoveFromFavorites: "Hapus dari favorit", // translated 
  quotationRequestChatSubmitted: "Terkirim", // translated 
  quotationRequestChatQuotationRequest: "Permintaan Penawaran: {{reference}}", // translated 
  quotationRequestChatQuotationTooltipTitle: "{{judul}}", // translated 
  quotationRequestChatQuotationTooltipStatus: "- Status: {{status}}", // translated 
  quotationChatLoading: "Memuat...", // translated 
  quotationChatSessionNotFound: "Sesi dialog tidak dibuka untuk penawaran ini", // translated 
  quotationChatMemberSessionNotFound: "Sesi anggota tidak ditemukan untuk akun Anda", // translated 
  quotationChatUnableToConnect: "Tidak dapat terhubung ke percakapan", // translated 
  quotationChatConnecting: "Mengajak...", // translated 
  quotationChatTypeYourMessage: "ketik pesan Anda...", // translated 
  quotationChatConnected: "Terhubung", // translated 
  quotationChatConnectingStatus: "Mengajak...", // translated 
  quotationChatDisconnected: "Terputus", // translated 
};


export default quotationChat;
